import { errorMsgList } from './errorMsg';

export function GetHeaders(token) {

    let gotToken = token;
    let heards = {
        "x-correlation-id": guid,
        "x-source-country": "HK",
        "x-source-date-time": new Date().getTime(),
        "x-source-id": "BV",
        // "x-acc-op": gotToken,
        'Content-Type': 'application/json'
    }
    if (gotToken) {
        // gotToken = await getLocalToken();
        heards.API_KEY = gotToken;

    }
    return heards;
}

export function getLocalToken() {
    let token = LocalToken.getToken();
    if (!token) {
        return new Promise((resolve, reject) => {
            var myInterval = setInterval(() => {
                token = LocalToken.getToken();
                if (token) {
                    clearInterval(myInterval);
                    resolve(token);
                }
            }, 200);
        });
    }
    else {
        return Promise.resolve(token);
    }
}

export function SetCookie(name, value, expires) {
    if (expires) {
        let expiresTime = new Date(new Date().getTime() + 1000 * 60 * 60 * expires).toGMTString();
        document.cookie = name + "=" + (value || "") + ";expires=" + expiresTime;
    } else {
        document.cookie = name + "=" + (value || "");
    }

}

export function GetCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}


export function toCommonUser(userInfo) {
    if (!userInfo) {
        LocalLoginUserJWT.setUser(JSON.stringify(CurrentUser));
        return;
    }
    let UserInfo = {
        CellPhone: "",
        Department: userInfo.department || "-",
        Email: userInfo.email || "-",
        JobTitle: userInfo.jobTitle || userInfo.rank || "-",
        LanId: userInfo.userLanId,
        ManagerLanId: userInfo.managerLanId || "-",
        Name: userInfo.displayName,
        OfficeLocation: userInfo.officeLocation || "-",
        PhotoURL: userInfo.photoUrl || "",
        Division: userInfo.division || "-",
        Entity: userInfo.entity || "-",
        // UserPrincipalName: "A5135079@OCBCGROUP.OCBC.COM",
        WorkPhone: "",
        OrgName1: userInfo.orgName1 || "",
        OrgName2: userInfo.orgName2 || "",
        OrgName3: userInfo.orgName3 || "",
        OrgName4: userInfo.orgName4 || "",
        OrgName5: userInfo.orgName5 || "",
        OrgName6: userInfo.orgName6 || "",
        OrgName7: userInfo.orgName7 || "",
        EmpId: userInfo.empId,
        CostCenter: userInfo.costCenter
    }
    LocalLoginUserJWT.setUser(JSON.stringify(UserInfo));
    return UserInfo;
}

export function toCommonUserFromUserInfo(userInfo) {
    if (!userInfo) {
        LocalLoginUserJWT.setUser(JSON.stringify(CurrentUser));
        return;
    }
    let UserInfo = {
        CellPhone: userInfo.cellPhone || "",
        Department: userInfo.department || "-",
        Email: userInfo.email || "-",
        JobTitle: userInfo.jobTitle || "-",
        LanId: userInfo.lanId,
        ManagerLanId: userInfo.managerLanId || "-",
        Name: userInfo.name,
        OfficeLocation: userInfo.officeLocation || "-",
        PhotoURL: userInfo.photoURL || "",
        Division: userInfo.employeeDivision || "-",
        Entity: userInfo.legalEntity || "-",
        UserPrincipalName: userInfo.userPrincipalName || "",
        WorkPhone: userInfo.workPhone || "",
        OrgName1: userInfo.orgName1 || "",
        OrgName2: userInfo.orgName2 || "",
        OrgName3: userInfo.orgName3 || "",
        OrgName4: userInfo.orgName4 || "",
        OrgName5: userInfo.orgName5 || "",
        OrgName6: userInfo.orgName6 || "",
        OrgName7: userInfo.orgName7 || "",
        EmpId: userInfo.empId,
        CostCenter: userInfo.costCenter
    }
    LocalLoginUserJWT.setUser(JSON.stringify(UserInfo));
    return UserInfo;
}

export const guid = getGUID();

export function getGUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        let r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & (0x3)) | (0x8);
        return v.toString(16);
    });
}

export function setLocalToken(token, callback) {
    if (token) {
        LocalToken.setToken();
        if (callback) {
            callback();
        }
    }
}

export const LocalToken = (function () {
    let _savedToken;
    return {
        getToken: function () {
            if (_savedToken === undefined) {
                _savedToken = '';
            }
            return _savedToken;
        }
        , setToken: function (newToken) {
            _savedToken = newToken;
        }
    }
})();

const LocalLoginUserJWT = (function () {
    let savedUser;

    return {
        getUser: function () {
            if (savedUser === undefined) {
                savedUser = '';
            }
            return savedUser;
        }
        , setUser: function (newUserJWT) {
            savedUser = newUserJWT;
        }
    }
})();

export const getTips = (code, Lang) => {
    let msg;
    let keyWord = code + Lang;

    for (let key in errorMsgList) {
        if (key === keyWord) {
            msg = errorMsgList[key];
            break;
        }

    }

    return msg;
}


let UserInfo = {
    // LanID: "a5135079"
    // , Name: "Hua Kang"

    // LanID: "a5131940"
    // , Name: "Mark Jonathan @Yen Lung"

    // LanID: "A5138968"
    // , Name: "Li Yun Feng"

    //  LanID: "A5130275"
    // , Name: " Wu Chuan Ping"

    // LanID: "A5142754"
    // , Name: "Tang Jian"

    // LanID: "A5141178"
    // , Name: "Chen Chao"

    LanID: "a5135393"
    , Name: "Zhu Chi Feng (Cliff)"

    // LanID: "A5144643"
    // , Name: "Xu Shi Min (Simon)"

    // LanID: "a5141767"
    // , Name: "Yuan Jie (Aiden)"

    // LanID: "a5135393"
    // , Name: "Huang Fang (Crystal)"

    // LanID:"a5135263"
    // ,Name: "Huang Shao Biao (Titus)"

    // LanID:"a5136151"
    // ,Name: "Zhang Fei Xiang (Sail)"

    // LanID:"A5140099"
    // ,Name: "Chen Guoping"

    // LanID:"A5136787"
    // ,Name: "Tan Yu Qing Gerard"

    // LanID: "a5135473"
    // , Name: "Low Zhen Yi, Adeline (Addie)"

    // LanID: "a5137923"
    // , Name: "Chan Ka Lok Victor"
}
// export const CurrentUser = { "data": { "d": { "__metadata": { "id": "http://dwshrapos0b:16000/ewf/_api/Web/GetUserById(48)", "uri": "http://dwshrapos0b:16000/ewf/_api/Web/GetUserById(48)", "type": "SP.User" }, "Groups": { "__deferred": { "uri": "http://dwshrapos0b:16000/ewf/_api/Web/GetUserById(48)/Groups" } }, "Id": 48, "IsHiddenInUI": false, "LoginName": "i:0#.w|ocbcgroup\\" + UserInfo.LanID, "Title": UserInfo.Name, "PrincipalType": 1, "Email": "HuaKang@ocbc.com", "IsSiteAdmin": false, "UserId": { "__metadata": { "type": "SP.UserIdInfo" }, "NameId": "s-1-5-21-1436318678-1461800975-2018848785-247228", "NameIdIssuer": "urn:office:idp:activedirectory" } } } };
export const CurrentUser = {
    CellPhone: "",
    Department: "CHN Regional Development Center",
    Email: UserInfo.LanID + "@ocbc.com",
    JobTitle: "Assistant Manager 7",
    LanId: UserInfo.LanID,
    ManagerLanId: "OCBCGROUP\\" + UserInfo.ManagerLanId ? "a5131940" : UserInfo.LanID,
    Name: UserInfo.Name,
    OfficeLocation: "CN",
    PhotoURL: "",
    UserPrincipalName: UserInfo.LanID + "@OCBCGROUP.OCBC.COM",
    WorkPhone: "",
    OrgName1: "OrgName1",
    OrgName2: "OrgName2",
    OrgName3: "OrgName3",
    OrgName4: "OrgName4",
    OrgName5: "CHN Regional Development Center",
    OrgName6: "OrgName6",
    OrgName7: "OrgName7",
    Entity: "OCBC China",
    Division: "e2 Power Division",
    EmpId: UserInfo.LanID.replace("A5", "").replace("a5", ""),
    CostCenter: "120"
};